// Sassファイルの読み込み
import '../scss/style.scss';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createPersistedState } from "pinia-plugin-persistedstate";
import VueGtag from 'vue-gtag';
import LoginForm from './components/organisms/LoginForm.vue';
import ForgotPasswordForm from './components/organisms/ForgotPasswordForm.vue';
import ResetPasswordForm from './components/organisms/ResetPasswordForm.vue';
import TeamProfile from './components/organisms/TeamProfile.vue';
import FeatureEvents from './components/organisms/FeatureEvents.vue';
import AuthArea from './components/organisms/AuthArea.vue';
import OauthGoogleSign from './components/pages/OauthGoogleSign.vue';
import OauthFacebookSign from './components/pages/OauthFacebookSign.vue';
import ConfirmationForm from './components/organisms/ConfirmationForm.vue';
import OauthConfirmationForm from './components/organisms/OauthConfirmationForm.vue';
import UserConfirmation from './components/atoms/UserConfirmation.vue';
import PostBlock from './components/atoms/PostBlock.vue';
import MenuItemSettings from './components/atoms/MenuItemSettings.vue';
import MenuItemUserName from './components/atoms/MenuItemUserName.vue';
// ドロワーメニュー
import Drawer from './modules/drawer';
// TOPスライダー
import slideshow from './modules/swiper';
// sweet-scroll
import pageScroll from './modules/pageScroll';
// toggle制御
import toggle from './modules/btnToggle';
window.onload = function () {
    new slideshow();
    new pageScroll();
    new toggle();
    new Drawer();
};
document.addEventListener('DOMContentLoaded', function () {
    var app = createApp({});
    var pinia = createPinia();
    pinia.use(createPersistedState());
    app.use(pinia);
    var domain = window.location.host;
    if (domain === 'media.engate.jp') {
        app.use(VueGtag, {
            config: {
                id: "G-ZQETJ1LN0W",
            }
        });
    }
    app.component('login-form', LoginForm);
    app.component('auth-area', AuthArea);
    app.component('confirmation-form', ConfirmationForm);
    app.component('oauth-confirmation-form', OauthConfirmationForm);
    app.component('forgot-password-form', ForgotPasswordForm);
    app.component('reset-password-form', ResetPasswordForm);
    app.component('team-profile', TeamProfile);
    app.component('feature-events', FeatureEvents);
    app.component('user-confirmation', UserConfirmation);
    app.component('post-block', PostBlock);
    app.component('menu-item-settings', MenuItemSettings);
    app.component('menu-item-user-name', MenuItemUserName);
    app.component('oauth-google-sign', OauthGoogleSign);
    app.component('oauth-facebook-sign', OauthFacebookSign);
    app.mount('#app');
});
